import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TicketService, Ticket, TicketDetails, TicketQuery, toNumber } from '@fgb/core';
import { SortOptions } from '@fgb/portal-component-library/src/lib/directives';
import { FilterFn } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgbcl-ticket-list',
  templateUrl: './ticket-list.component.html',
  styleUrls: ['./ticket-list.component.scss'],
})
export class TicketListComponent implements OnInit {
  @Input() filters: FilterFn[];
  @Input() sortOptions: SortOptions<any>;
  @Input() transferWindowExists: boolean;
  @Input() transferWindowOpen: boolean;
  @Input() ticketColumn1: TicketDetails = TicketDetails.Area;
  @Input() ticketColumn2: TicketDetails = TicketDetails.Stand;
  @Output() onDataChange: EventEmitter<Ticket[]> = new EventEmitter<Ticket[]>();
  ticketList$: Observable<Ticket[]>;

  constructor(private ticketService: TicketService, private route: ActivatedRoute, private ticketQuery: TicketQuery) {}

  ngOnInit() {
    
    const gameNumber = toNumber(this.route.snapshot.paramMap.get('gameNumber'));

    this.ticketList$ = this.ticketQuery.selectTicketsForGame(gameNumber);
    this.ticketService.resetTransferredTickets();
  }

}
